/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Microchip = [
  ["path", { d: "M10 12h4" }],
  ["path", { d: "M10 17h4" }],
  ["path", { d: "M10 7h4" }],
  ["path", { d: "M18 12h2" }],
  ["path", { d: "M18 18h2" }],
  ["path", { d: "M18 6h2" }],
  ["path", { d: "M4 12h2" }],
  ["path", { d: "M4 18h2" }],
  ["path", { d: "M4 6h2" }],
  ["rect", { x: "6", y: "2", width: "12", height: "20", rx: "2" }]
];

export { Microchip as default };
//# sourceMappingURL=microchip.js.map
